export default {
	HEADER: 'Areas',
	NAV_HEADER: 'Count Areas'
};